import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  background-color: var(--color-white);
  padding: 40px 40px;
  outline: none;
  max-width: 90vw;
  min-width: 1000px;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled.p`
  color: var(--color-oxford-blue);
  text-align: center;
  margin-bottom: 8px;
  word-break: break-word;

  font-weight: bold;
  font-size: 24px;
`
